import { type FunctionComponent } from 'react';
import { defaultCloudinaryOptions } from '../../../constants/images';
import { BaseImage } from '../base-image/base-image.component';

export type PlaceholderImageProps = {
	width?: number;
	height?: number;
	className?: string;
	bypassLazyLoad?: boolean;
};

/**
 * This placeholder allows us to set a viewBox that is the same ratio as the image so it can scale in the same way the actual image
 * does.  We also want the same structure as our actual component so the diff in the virtual dom has less changes to deal with.
 */
export const PlaceholderImage: FunctionComponent<PlaceholderImageProps> = ({ width, height, bypassLazyLoad = false, className = '' }) => {
	const dimensions: Partial<Pick<HTMLImageElement, 'width' | 'height'>> = {
		width,
		height
	};
	const shouldUseDimensions = Boolean(width || height);
	width = width || defaultCloudinaryOptions.width;
	height = height || defaultCloudinaryOptions.height;
	const placeholderSrc = `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}"%3E%3C/svg%3E`;
	return (
		<BaseImage
			source={placeholderSrc}
			bypassLazyLoad={bypassLazyLoad}
			dimensions={dimensions}
			className={`placeholder ${className}`}
			shouldUseDimensions={shouldUseDimensions}
			description="placeholder"
		/>
	);
};
